<script>
/*
 * This component displays a confirm dialog showing a question / message. Use the emitted events confirm and refuse
 * to react on the users click on the yes or no button.
 */
export default {
  name: 'RbxConfirmDialog',
  props: {
    message: {
      type: String,
      required: true,
    },
    isDisplayed: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    confirmText: {
      type: String,
      required: false,
      default: 'Ja',
    },
    rejectText: {
      type: String,
      required: false,
      default: 'Nein',
    },
  },
  data() {
    return {
    };
  },
  watch: {
    selected() {
      this.selectedItem = this.selected;
    },
  },
  mounted() {
    this.selectedItem = this.selected;
  },
  methods: {
    refuse() {
      this.$emit('refuse');
    },
    confirm() {
      this.$emit('confirm');
    },
  },
};
</script>

<template>
  <v-dialog v-model="isDisplayed" persistent max-width="768">
    <v-card>
      <v-card-title class="title pa-3"/>

      <v-card-text>
        <v-container grid-list-md class="pa-0">

          <v-flex xs12 md12 py-0>
            <v-flex xs12 md12 py-0>
              {{ message }}
            </v-flex>
          </v-flex>

        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn
          small outline
          @click.native="refuse()"
        >
          {{ rejectText }}
        </v-btn>

        <v-btn
          :loading="isLoading"
          color="success" small depressed dark
          @click.native="confirm()"
        >
          {{ confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
